import { render, staticRenderFns } from "./IssuesTypesForm.vue?vue&type=template&id=27cd0881"
import script from "./IssuesTypesForm.vue?vue&type=script&lang=js"
export * from "./IssuesTypesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports